export default {
  accentColor: '#FF3B30',

  windowBackground: '#fff',
  // underPageBackground: 'rgb(240, 245, 246)',
  underPageBackground: '#f7f8f9',
  // underPageBackground: '#fff',
  controlBackground: 'rgb(240, 245, 246)',
  // controlBackground: '#f1f1f1',
  textColor: '#000',
  secondaryTextColor: '#222',

  separatorColor: '#ddd',
  borderColor: '#aaa',
  noteColor: '#8E8E93',
};


